"use strict";
import u from "./index.es154.js";
function i(n) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(n).replace(/[!'()~]|%20|%00/g, function(r) {
    return t[r];
  });
}
function e(n, t) {
  this._pairs = [], n && u(n, this, t);
}
const o = e.prototype;
o.append = function(n, t) {
  this._pairs.push([n, t]);
};
o.toString = function(n) {
  const t = n ? function(r) {
    return n.call(this, r, i);
  } : i;
  return this._pairs.map(function(r) {
    return t(r[0]) + "=" + t(r[1]);
  }, "").join("&");
};
export {
  e as default
};
//# sourceMappingURL=index.es348.js.map
